/* @flow */

import _RevertInput from './RevertInput';

export default _RevertInput;



// WEBPACK FOOTER //
// ./src/components/RevertInput/index.js